import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { toSearchString } from 'utils/url';
import { formatNumber } from 'packages';

const CategoryPageLink = ({ category, queryParams, onClick }) => (
    <Link
        to={{
            pathname: category.url,
            search: toSearchString(queryParams)
        }}
        onClick={onClick}
        data-test-category-link
        className={`d-flex category-link justify-content-between py-1 text-primary
                ${category.status === 'active' &&
                    'text-dark font-weight-bold'}`}>
        <div className="category-link-title">{category.name}</div>
        <div className="text-muted pl-2">
            {!category.children && formatNumber(category.count)}
        </div>
    </Link>
);

CategoryPageLink.defaultProps = {
    category: {}
};

CategoryPageLink.propTypes = {
    category: PropTypes.object,
    queryParams: PropTypes.object,
    onClick: PropTypes.func
};

export default CategoryPageLink;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-results/filters/categories/category-page-link.jsx